export default __webpack_public_path__ + "static/media/my-leaves-black.2e93b141.svg";